import { selectOidcConfig } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';
import { useSignupData } from '../useSignupData';

export const useShortcutSSOStep = () => {
  const storedOidcConfig = useSelector(selectOidcConfig);
  const { currentStep } = useSignupData();

  const submit = async (
    accessCode: string,
    handleOIDCSignIn: (oidcConfig: any, options: { accessCode: string }) => Promise<void>,
  ) => {
    if (!storedOidcConfig) {
      console.error('No OIDC configuration found');
      return;
    }

    await handleOIDCSignIn(storedOidcConfig, { accessCode });
  };

  return { submit };
};
